import IAsyncArgs from "../../../shared/contracts/IAsyncArgs";
import useHelpers from "../../../shared/services/helpers/useHelpers.hook";
import IUserDetails from "../../../shared/contracts/IUserDetails";
import IUserTenants from "../../../shared/contracts/IUserTenants";
import useApi from "../../../shared/services/useApi.hook";
import useAppStoreContext from "../../../shared/context/app-store/app-store.context";

function useReportingUserApi() {

  const { NORMALIZE_KEYS } = useHelpers();
  const {  userNameGlobally, setUserNameGlobally, userDetails } = useAppStoreContext();

  const { GET, TENANT_ID, } = useApi();
  const BASE_URL: string = `${process.env.REACT_APP_ENTRA_IDENTITY_URL}`;
 
  // Function with parameter defined inside the hook
 const updateUserName = (newName: any) => {
  setUserNameGlobally(newName);
};

  const getUserDetails = (
    { doIf,
      doBefore = () => { },
      doAfter = () => { },
      onFulfilled,
      onException = (exception: any) => { console.warn('exception', exception); },
    }: IAsyncArgs<IUserDetails>
  ): void => {

    if (doIf()) {
      GET<IUserDetails>(`${BASE_URL}/User/${userNameGlobally}`,
        doBefore,
        (fulfilled) => onFulfilled(fulfilled),
        (rejection) => onException(rejection),
        (exception) => onException(exception),
        doAfter
      );
    }
  }

  //const userId = userDetails.userID;
  const getUserTenants = (
    { doIf,
      doBefore = () => { },
      doAfter = () => { },
      onFulfilled,
      onException = (exception: any) => { console.warn('exception', exception); },
    }: IAsyncArgs<IUserTenants[]>
  ): void => {

    if (doIf()) {
      GET<IUserTenants[]>(`${BASE_URL}/User/UserTenants/3`,
        doBefore,
        (fulfilled) => onFulfilled(fulfilled),
        (rejection) => onException(rejection),
        (exception) => onException(exception),
        doAfter
      );
    }
  }

  // ---
  return {

    userNameGlobally, setUserNameGlobally,
    updateUserName,
    getUserDetails,
    getUserTenants,
  }

}
export default useReportingUserApi;